import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { Configuration, PublicClientApplication } from '@azure/msal-browser';

const AuthAzure = ({ children }: { children: React.ReactElement }) => {
  const externalAuthEnabled = import.meta.env.VITE_AUTH0_ENABLED === 'true';
  const authorityId = import.meta.env.VITE_SP_ENTITY_ID;
  const applicationId = import.meta.env.VITE_SP_CLIENT_ID;

  const configuration: Configuration = {
    auth: {
      clientId: applicationId,
      redirectUri: import.meta.env.VITE_SP_REDIRECT_URI,
      authority: `https://login.microsoftonline.com/${authorityId}`,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'sessionStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
  };
  const pca = new PublicClientApplication(configuration);

  return (
    externalAuthEnabled ? (
      <MsalProvider instance={pca}>
        {children}
      </MsalProvider>
    ) : children
  );
};

export default AuthAzure;
